import React, { useEffect } from "react";
import Switch from "react-switch";
import { useTranslation } from "react-i18next";
import { StyledH2 } from "@aureskonnect/react-ui";
import classNames from "classnames";
import { AvForm, AvRadioGroup, AvRadio } from "availity-reactstrap-validation";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";

import { store, setOptions, setOptionComposite } from "../store";

import "./index.css";

export default function Options({ selectedRows }: any) {
    const { t } = useTranslation();
    const [activateButton, setActiveButton] = React.useState<boolean>(
        selectedRows.length > 0
            ? selectedRows[0]["Connexion client"] !== undefined
                ? selectedRows[0]["Connexion client"]
                : false
            : false
    );
    const { optionComposite } = useSnapshot(store);
    const [mandatoryEmail, setMandatoryEmail] = React.useState<boolean>(
        selectedRows.length > 0
            ? selectedRows[0]["mandatory Email"] !== undefined
                ? selectedRows[0]["mandatory Email"]
                : false
            : false
    );

    const [validatingOrder, setValidatingOrder] = React.useState<boolean>(
        selectedRows.length > 0
            ? selectedRows[0]["Contact shop"] !== undefined
                ? selectedRows[0]["Contact shop"]
                : false
            : false
    );
    const [compositeProducts, setCompositeProducts] = React.useState<string>(
        Object.values(selectedRows).length > 0
            ? selectedRows[0]["composite Products"] !== undefined
                ? selectedRows[0]["composite Products"].REGLEGRATUITE === "1"
                    ? `${t("The next in The list")}`
                    : selectedRows[0]["composite Products"].REGLEGRATUITE ===
                      "2"
                    ? `${t("The cheapest")}`
                    : selectedRows[0]["composite Products"].REGLEGRATUITE ===
                      "3"
                    ? `${t("The most expensive")}`
                    : ""
                : ""
            : ""
    );

    useEffect(() => {
        let products =
            compositeProducts === `${t("The Next In The List")}`
                ? "1"
                : compositeProducts === `${t("The cheapest")}`
                ? "2"
                : compositeProducts === `${t("The most expensive")}`
                ? "3"
                : "";

        const composite: any = {
            ...optionComposite,
            REGLEGRATUITE: products,
            CMD_DIFFERE: optionComposite.CMD_DIFFERE,
        };

        setOptionComposite(composite);
        const dataOptions = {
            activateButton,
            mandatoryEmail,
            validatingOrder,
        };

        setOptions(dataOptions);
        // eslint-disable-next-line
    }, [
        activateButton,
        mandatoryEmail,
        validatingOrder,
        compositeProducts,
        selectedRows,
        t,
    ]);

    return (
        <React.Fragment>
            <StyledH2
                style={{
                    font: "normal normal 400 27px/41px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 pt-3"
            >
                {t("Options")}
            </StyledH2>
            <StyledH2
                style={{
                    font: "normal normal 400 20px/27px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 pt-3"
            >
                {t("Customer login")}
            </StyledH2>
            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <span
                    className="ml-5"
                    style={{
                        font: "normal normal 400 16px/24px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                >
                    {t("Activate the ''Quick connect'' button")}
                </span>

                <ReactSwitch
                    className="cac_icn_quickConnection"
                    offColor="#faafb4"
                    offHandleColor="#E30613"
                    onColor="#c2eec4"
                    onHandleColor="#34C38F"
                    height={19}
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    checked={activateButton}
                    onChange={(e: any) => {
                        setActiveButton(!activateButton);
                    }}
                />
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <span
                    className="not-allowed-icon__clz ml-5 "
                    style={{
                        font: "normal normal 400 16px/24px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                >
                    {t("Allow order taking without customer authentication")}
                </span>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <span
                    style={{
                        font: "normal normal 400 16px/24px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                    className={classNames("ml-5", {
                        "not-allowed-icon__clz ml-5": activateButton === false,
                    })}
                >
                    {t(
                        "Mandatory email for the case of a ''Quick connection''"
                    )}
                </span>
                <Switch
                    className="cac_icn_emailRequiredQuickConnection"
                    offColor="#faafb4"
                    offHandleColor="#E30613"
                    onColor="#c2eec4"
                    onHandleColor="#34C38F"
                    height={19}
                    disabled={!activateButton}
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    checked={mandatoryEmail}
                    onChange={(e: any) => {
                        setMandatoryEmail(!mandatoryEmail);
                    }}
                />
            </div>
            <div className="border-footer__clz m-1 px-2 option__clz" />
            <StyledH2
                style={{
                    font: "normal normal 400 20px/27px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5  pt-3"
            >
                {t("Contact shop")}
            </StyledH2>
            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <span
                    className="ml-5"
                    style={{
                        font: "normal normal 400 16px/24px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                >
                    {t(
                        "Activate the ''Call the shop'' icon when validating the order"
                    )}
                </span>

                <Switch
                    className="cac_icn_callTheStore"
                    offColor="#faafb4"
                    offHandleColor="#E30613"
                    onColor="#c2eec4"
                    onHandleColor="#34C38F"
                    height={19}
                    handleDiameter={24}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    checked={validatingOrder}
                    onChange={(e: any) => {
                        setValidatingOrder(!validatingOrder);
                    }}
                />
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 ml-3 px-5">
                <span
                    className=" not-allowed-icon__clz ml-5 "
                    style={{
                        font: "normal normal 400 16px/24px Segoe UI",
                        color: "#000000",
                        opacity: "1",
                    }}
                >
                    {t("This option is available for the app only")}
                </span>
            </div>

            <div className="border-footer__clz px-2 option-free__clz " />
            <StyledH2
                style={{
                    font: "normal normal 400 20px/27px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5  pt-3"
            >
                {t("Free rules for composite products")}
            </StyledH2>

            <AvForm model={{ form: compositeProducts, checkItOut: true }}>
                <AvRadioGroup
                    name="form"
                    required
                    inline
                    errorMessage="Pick one!"
                    className="ml-5"
                >
                    <div className="p-2 ml-5">
                        <AvRadio
                            className="cac_chk_nextInTheList"
                            id="oneRadio"
                            label={
                                <span
                                    style={{
                                        font:
                                            "normal normal 400 16px/24px Segoe UI",
                                        color: "#000000",
                                        opacity: "1",
                                    }}
                                >
                                    {t("The next in The list")}
                                </span>
                            }
                            value={t("The next in The list")}
                            disabled={false}
                            onChange={() => {
                                setCompositeProducts(
                                    `${t("The Next In The List")}`
                                );
                            }}
                        />
                    </div>

                    <div className="p-2 ml-5 ">
                        <AvRadio
                            className="cac_chk_theCheapest"
                            id="twoRadio"
                            label={
                                <span
                                    style={{
                                        font:
                                            "normal normal 400 16px/24px Segoe UI",
                                        color: "#000000",
                                        opacity: "1",
                                    }}
                                >
                                    {t("The cheapest")}
                                </span>
                            }
                            value={t("The cheapest")}
                            disabled={false}
                            onChange={() => {
                                setCompositeProducts(`${t("The cheapest")}`);
                            }}
                        />
                    </div>
                    <div className="p-2 ml-5 ">
                        <AvRadio
                            className="cac_chk_theMostExpensive"
                            id="threeRadio"
                            label={
                                <span
                                    style={{
                                        font:
                                            "normal normal 400 16px/24px Segoe UI",
                                        color: "#000000",
                                        opacity: "1",
                                    }}
                                >
                                    {t("The most expensive")}
                                </span>
                            }
                            value={t("The most expensive")}
                            disabled={false}
                            onChange={() => {
                                setCompositeProducts(
                                    `${t("The most expensive")}`
                                );
                            }}
                        />
                    </div>
                </AvRadioGroup>
            </AvForm>
        </React.Fragment>
    );
}
